import { mutatorAction } from 'satcheljs';
import mailGroupHeadersStore from '../store/store';

export const addGroupHeaderAction = mutatorAction('addGroupHeader', (groupHeaderId: string) => {
    mailGroupHeadersStore().groupHeaders.set(groupHeaderId, true);
});
